// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-nav {
  --top-nav-height-animation: 0.3s ease-in-out;
  --top-nav-height: 64px;
  --top-nav-inner-height: 64px;
}

.top-nav--is-mobile {
  --top-nav-height: 60px;
  --top-nav-inner-height: 60px;
}

.top-nav--with-top-area-banner {
  --top-nav-height: 98px;
  --top-nav-inner-height: 64px;
}

.top-nav--search-input-visible.top-nav--is-mobile {
  --top-nav-height: 119px;
  --top-nav-inner-height: 60px;
}

.top-nav--with-top-area-banner.top-nav--search-input-visible.top-nav--is-mobile {
  --top-nav-height: 153px;
  --top-nav-inner-height: 60px;
}

.top-nav--with-top-area-banner.top-nav--is-mobile {
  --top-nav-height: 94px;
  --top-nav-inner-height: 60px;
}

.top-nav--no-scroll {
  overflow: hidden;
}

#online-top-area-root {
  height: auto;
  height: initial;
}

#top-area {
  height: var(--top-nav-height);
  transition: height var(--top-nav-height-animation);
}
`, "",{"version":3,"sources":["webpack://./../../packages/top-area/dist/cjs/App.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAa;EAAb,eAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD","sourcesContent":[".top-nav {\n  --top-nav-height-animation: 0.3s ease-in-out;\n  --top-nav-height: 64px;\n  --top-nav-inner-height: 64px;\n}\n\n.top-nav--is-mobile {\n  --top-nav-height: 60px;\n  --top-nav-inner-height: 60px;\n}\n\n.top-nav--with-top-area-banner {\n  --top-nav-height: 98px;\n  --top-nav-inner-height: 64px;\n}\n\n.top-nav--search-input-visible.top-nav--is-mobile {\n  --top-nav-height: 119px;\n  --top-nav-inner-height: 60px;\n}\n\n.top-nav--with-top-area-banner.top-nav--search-input-visible.top-nav--is-mobile {\n  --top-nav-height: 153px;\n  --top-nav-inner-height: 60px;\n}\n\n.top-nav--with-top-area-banner.top-nav--is-mobile {\n  --top-nav-height: 94px;\n  --top-nav-inner-height: 60px;\n}\n\n.top-nav--no-scroll {\n  overflow: hidden;\n}\n\n#online-top-area-root {\n  height: unset;\n}\n\n#top-area {\n  height: var(--top-nav-height);\n  transition: height var(--top-nav-height-animation);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
